import type { FaireProductEntity } from "../../entity_types/product";

export const p_fzf8zp2cym: FaireProductEntity = {
  token: "p_fzf8zp2cym",
  type: "product",
  name: "Aced It Congrats Card Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7ce53e1759280a289fa34f942ee60f82b5ebdc9853bd12ac80d413f2a626da7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e2c081091ffa77c2bd8774f899c8ef328ac378b2cc8c66839ac2d31ba5ac15a.jpeg",
    "https://cdn.faire.com/fastly/786663f6d79e0945cf24e44a644620609e90a53812a1b9b84f40b53608a05c7b.webp",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:53.577Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
